export const AUTH_TOKEN_NAME = 'authTokenName';
export const LOGIN_ROUTE = 'authLoginRoute';
export const AUTH_MANAGER_TOKEN_NAME = 'authManagerTokenName';
